import { Fragment,useState } from 'react'


const Menu = ({navigator}) => {
   const [message,setMessage] = useState("");
   const validateForm = function(formData){
       var object = {};
       formData.forEach((value, key) => object[key] = value);
       if (object['name'] == "") {setMessage("Name must not be empty"); return false;}
       if (object['process'] == "") {setMessage("Process must not be empty"); return false;}
       return true;
   }

   /* What is our data structure for the menu? a menu is a  */
   const [selected, setSelected] = useState('start');
   const reportMenu =[
   	 {"id": "report/new","label":"New"},
   	 {"id": "report/list","label":"List"},
	 ];
   const menu = [
   	 {"id": "start","label":"Welcome", "children":null},
   	 {"id": "reports","label":"Reports", "children":reportMenu},
	 {"id": "regions","label":"Regions of Interest","children":null},
	 {"id": "status","label":"System Status","children":null},
	 {"id": "console","label":"Console","children":null}
	 ];



   const renderMenu=(tag="")=>{
       let ret = menu.map((item)=>{
       	   return <Fragment key={"menu-"+item['id']}>
	   <li className={tag==item['id']?"is-current is-active":""}>
	   <a aria-current={tag==item['id']?"page":""} className="" onClick={()=>navigate(item['id'])}>
           {item["label"]}
	   </a></li></Fragment>
       });
       return ret;
   }
   
   let [menuHTML, setMenuHTML] =useState(renderMenu("start"));
   const navigate = (tag)=>{
      console.log("Navigating to "+tag);
      navigator(tag);
      setMenuHTML(renderMenu(tag));
   };




return (
  <>
  <ul id="menuMain" className="accordion c-sitenav__menu">
      {menuHTML}
  </ul>
  </>
);
};

export default Menu;
